/*
 * Layout Messages
 *
 * This contains all the strings for the BreadcrumbsDropdown component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  // Information menu item
  information: 'Information',
  // Deal Plus title button
  dealPlusTitle: 'Deal+',
  // Game Platform link title
  gameLinkTitle: 'Game Platform',
  // Megopoly link title
  megopolyLinkTitle: 'Megopoly',
  // Wisdom link title
  grcLinkTitle: 'GRC',
  // Wenda link title
  wendaLinkTitle: 'Wenda',
  // Jemjar link title
  jemjarLinkTitle: 'Jemjar',
  // Title for download android app link
  androidApp: 'Android app',
  // Title for logout
  logout: 'Logout',
  // Network menu item
  network: 'Network',
  // Profile menu item
  profile: 'Profile',
  // Settings menu item
  settings: 'Settings',
  // Wealth menu item
  wealth: 'Wealth',
  // Archived history menu item
  archivedTransactions: 'History',
  // Document title
  title: 'Membership',
  // Download button
  download: 'Download',
  // Game platform only ch message,
  gamesPlatformOnlyCnMsg:
    'Best Deals rewards you for shopping online with points. Reward points can be exchanged for Bitcoin rewards in Shopping Bus 4 All and increase your GRC score. Chinese only.',
  // GRC chat
  chat: 'Chat',
});
